// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../../typings.d.ts" />

import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf, provideAppInitializer } from '@angular/core';
import browserUpdate from 'browser-update';

@NgModule({
  imports: [CommonModule],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (function () {
        return () =>
          new Promise((resolve) => {
            resolve(
              // https://github.com/browser-update/browser-update
              // https://browser-update.org/customize.html
              browserUpdate({
                // required: { e: -4, f: -4, o: 0, s: -1, c: -4 }, // this method temporarily disabled until they update their browser versions in NPM package
                required: { e: 86, f: 84, o: 0, s: 13, c: 86 },
                insecure: false,
                reminderClosed: 720,
                style: 'corner',
                test: false, // enable for dev testing
              })
            );
          });
      })();
        return initializerFn();
      }),
  ],
})
export class BrowserSupportModule {
  constructor(@Optional() @SkipSelf() parentModule: BrowserSupportModule) {
    // Check if NgModule was previously loaded
    // https://angular.io/guide/ngmodule-faq#how-can-i-tell-if-an-ngmodule-or-service-was-previously-loaded
    if (parentModule) {
      throw new Error(
        'BrowserSupportModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
